import { FormattedMessage } from 'react-intl';

const intlPrefix = 'exploreSection';

export const Header = (
  <FormattedMessage
    defaultMessage='Taking care of your watch'
    id={`${intlPrefix}.header`}
  />
);

export const DescriptionTop = (
  <FormattedMessage
    defaultMessage='Find our comprehensive set of services and assistance designed for you and your Breitling.'
    id={`${intlPrefix}.descriptionTop`}
  />
);

export const DescriptionBottom = (
  <FormattedMessage
    defaultMessage='Explore our comprehensive set of services and assistance designed for you and your Breitling.'
    id={`${intlPrefix}.descriptionBottom`}
  />
);

export const Link = (
  <FormattedMessage
    defaultMessage='Explore #BREITLINGCARE'
    id={`${intlPrefix}.link`}
  />
);
